import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatDialogModule} from "@angular/material/dialog";

@Component({
  selector: 'app-approve-dialog',
  standalone: true,
  imports: [
    MatDialogModule, MatButtonModule
  ],
  template: `
    <h2 mat-dialog-title>Are you sure you want to approve this request?</h2>
    <mat-dialog-content class="mat-typography">
      <p>Ensure all information is accurate and complete. By clicking "Approve,"
        this decision cannot be undone or reversed. </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button class="go-back" mat-button mat-dialog-close>GO BACK</button>
      <button class="approve" mat-button [mat-dialog-close]="true" cdkFocusInitial>APPROVE</button>
    </mat-dialog-actions>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApproveDialogComponent {

}
